import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import BeneficiaryAdults from './BeneficiaryAdults';
import BeneficiarySection from '../BeneficiarySection';
import BeneficiaryChildren from './BeneficiaryChildren';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { getBeneficiaryIcon } from '../BeneficiaryMainCard';
import { BeneficiaryAgeProps } from './BeneficiaryAdultValues';
import { beneficiaryAgeValidation } from '../utils/helperFunctions';
import { BeneficiaryTitleInfoProps } from '../utils/beneficiaryInterfaces';

const title = (
  programName: BeneficiaryTitleInfoProps['programName'],
  beneficiaryLabel?: string,
) => (
  <div>
    Select the age groups of{' '}
    <b>
      {(beneficiaryLabel === 'Animals' ? 'People' : beneficiaryLabel) ||
        'Beneficiaries'}
    </b>{' '}
    that <b>{programName}</b> serves.
  </div>
);
const note = (
  <TrueImpactText variant="body-italic">
    <strong>Note:</strong> The total for the Age Groups category must add up to
    100 percent.
  </TrueImpactText>
);

const StyledDiv = styled.div`
  margin-top: 24px;
`;

const BeneficiaryAge: React.FC<BeneficiaryAgeProps &
  BeneficiaryTitleInfoProps> = ({
  beneficiary,
  beneficiaryLabel,
  setBeneficiaries,
  programName,
}) => {
  const [errorMessage, setErrorMessage] = useState<string | undefined>(
    undefined,
  );

  useEffect(() => {
    if (!beneficiary || beneficiary.categories.length === 0) return;
    if (beneficiaryAgeValidation(beneficiary)) {
      setErrorMessage(undefined);
    } else {
      setErrorMessage('* All age categories must add up to 100%.');
    }
  }, [beneficiary, setErrorMessage]);

  if (beneficiary === undefined) return null;
  return (
    <BeneficiarySection
      icon={getBeneficiaryIcon('age')}
      setBeneficiaries={setBeneficiaries}
      category="age"
      heading="Age groups"
      title={title(programName, beneficiaryLabel)}
      note={note}
      errorMessage={errorMessage}
    >
      <BeneficiaryAdults
        beneficiary={beneficiary}
        setBeneficiaries={setBeneficiaries}
      />
      <StyledDiv>
        <BeneficiaryChildren
          beneficiary={beneficiary}
          setBeneficiaries={setBeneficiaries}
        />
      </StyledDiv>
    </BeneficiarySection>
  );
};

export default React.memo(BeneficiaryAge);
